import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { InfoToolTip } from './InfoToolTip';
import { T } from '../traks';
import {dataPlaceholder} from '../misc'
import { site_name } from '../Site';

const getLink = () => {
  if (IS_AKTIEDYSTEN_DK) {
    return "https://inspiration.aktiedysten.dk/vaekst-din-viden-risiko/";
  } else if (IS_AKTIEKAMPEN_SE) {
    return "https://aktiekampen.se";
  } else if (IS_INVESTSPIEL_DE) {
    return "https://investspiel.de";
  } else if (IS_TRADERR_COM) {
    return "https://traderr.com";
  } else {
    return "#";  
  }
}

//Component to display key figures for a stock
export const KeyFigures = (info) => {
  const link = getLink();
    return (
      <div className="py-4 px-3 ad_key_figures mx-2">
        <h4 className='mt-3'><T>Key Figures</T></h4>
        <div className='d-flex flex-wrap mt-4'>
          <Card className='ad_key_figures_card'>
            <CardBody>
              <div className='d-flex justify-content-between'>
                <h1>
                <T>BETA</T>
                </h1>
                <InfoToolTip 
                  title={<T>BETA</T>} 
                  tooltipText={<T>
                    <p><strong>What is it?</strong> BETA measures how much the stock price moves in relation to the overall market. If BETA is 1, the stock moves in sync with the market. If BETA is greater than 1, the stock is more volatile (it swings more).</p>
                    <p><strong>Why is it important?</strong> It shows how risky the stock is compared to the market. As a shareholder, you can use BETA to assess whether the stock matches your risk tolerance.</p>
                    <p>Note: BETA is the factor we use in {site_name} when you compete to have the best balance.</p>
                  </T>} 
                  link={link} 
                />
              </div>
              <p>
              {dataPlaceholder(info.beta)}
              </p>
            </CardBody>
          </Card>
          <Card className='ad_key_figures_card'>
            <CardBody>
              <div className='d-flex justify-content-between'>
                <h1>
                <T>ROIC (Return on Invested Capital)</T>
                </h1>
                <InfoToolTip 
                  title={<T>ROIC (Return on Invested Capital)</T>} 
                  tooltipText={<T>
                    <p><strong>What is it?</strong> ROIC measures how efficiently the company uses its assets to generate profits. It shows how well the company is making money from what it has invested in its business (equity and debt).</p>
                    <p>ROIC = Operating Profit x 100 / (Fixed Assets + Current Assets)</p>
                    <p><strong>Why is it important?</strong> It gives you, as a shareholder, an idea of how efficiently the company generates returns (profits) from what it uses to run the business. The higher the ROIC, the better the "bang for your buck"!</p>
                  </T>} 
                  link={link}
                />
              </div>
              <p>
              {dataPlaceholder(info.efficiencyRatios ? info.efficiencyRatios.ROIC : '')}
              </p>
            </CardBody>
          </Card>
          <Card className='ad_key_figures_card'>
            <CardBody>
              <div className='d-flex justify-content-between'>
                <h1>
                <T>P/E (Price/Earnings)</T>
                </h1>
                <InfoToolTip 
                  title={<T>P/E (Price/Earnings)</T>} 
                  tooltipText={<T>
                    <p><strong>What is it?</strong> It’s the ratio between the stock price and the company’s earnings per share.</p>
                    <p>P/E = Stock Price / Earnings per Share (EPS)</p>
                    <p><strong>Why is it important?</strong> It shows how much investors are willing to pay for each dollar the company earns. A high P/E ratio usually indicates that the market is paying more for earnings today because it expects the company to increase profits in the future. A low P/E ratio suggests the market expects lower growth in profits going forward.</p>
                    <p>Note: If EPS is negative, P/E cannot be calculated.</p>
                  </T>} 
                  link={link}
                />
              </div>
              <p>
              {dataPlaceholder(info.valuationRatios ? info.valuationRatios.PE : '')}
              </p>
            </CardBody>
          </Card>
          <Card className='ad_key_figures_card'>
            <CardBody>
              <div className='d-flex justify-content-between'>
                <h1>
                <T>ROE (Return on Equity)</T>
                </h1>
                <InfoToolTip 
                  title={<T>ROE (Return on Equity)</T>} 
                  tooltipText={<T>
                    <p><strong>What is it?</strong> It’s a ratio that shows how good the company is at generating profits from shareholders' investments.</p>
                    <p>Return on Equity = Net Income / Average Equity</p>
                    <p><strong>Why is it important?</strong> It helps you evaluate how efficiently the company uses your money as a shareholder.</p>
                    <p>Note: Average Equity = (Equity at the start of the period + Equity at the end of the period) / 2.</p>
                  </T>}
                  link={link}
                />
              </div>
              <p>
              {dataPlaceholder(info.efficiencyRatios ? info.efficiencyRatios.ROE : '')}
              </p>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  };
  


// WEBPACK FOOTER //
// ./src/c/KeyFigures.js